export default __webpack_public_path__ + "static/media/circular.f8c3201f.gif";